import React, { useState } from "react";
import './supportTool.css';
import * as otherSetupApi from "../../../api/other/other";
import { useEffect } from "react";

export const LANGUAGE_EXAMPLE = {
        structure: {
            voucher: {
                row1: [
                    {
                        type: "div",
                        textvie: "1️⃣ Voucher là gì?",
                        texteng: "1️⃣ What is a Voucher?"
                    },
                    {
                        type: "content",
                        textvie: "Voucher là phiếu quà tặng điện tử do hệ thống Azumaya phát hành, có thể quy đổi từ AzCoin (điểm thưởng của khách hàng) ",
                        texteng: "A voucher is an electronic gift certificate issued by the Azumaya system, which can be exchanged from AzCoin (customer reward points)."
                    },
                    {
                        type: "content",
                        textvie: "Hoặc được tặng bởi hệ thống khi khách thăng hạng hoặc tình huống đặt biệt",
                        texteng: "Or given by the system when the customer is upgraded or in special situations."
                    },
                    {
                        type: "content",
                        textvie: "* Giảm trừ trực tiếp vào hóa đơn hoặc tặng cho khách.",
                        texteng: "* Directly deducted from the invoice or given to the customer.",
                    },
                    {
                        type: "content",
                        textvie: "* Mỗi voucher có giá trị nhất định và chỉ được sử dụng một lần.",
                        texteng: "* Each voucher has a certain value and can only be used once.",
                    },
                ],
                row2: [
                    {
                        type: "div",
                        textvie: "2️⃣ Bảng quy đổi AzCoin ⇄ Voucher",
                        texteng: "2️⃣ AzCoin ⇄ Voucher Exchange Table",
                    },
                    {
                        type: "content",
                        textvie: "Khách hàng có thể truy cập vào phần Coupo trên ứng dụng để qui đổi",
                        texteng: "Customers can access the Coupo section on the application to exchange.",
                    },
                    {
                        type: "content",
                        textvie: "* Coupon / Voucher khi đã qui đổi có thể được hoàn trả khi khách hàng thao tác.",
                        texteng: "* Coupon / Voucher once exchanged can be refunded when the customer operates.",
                    },
                    {   
                        type: "content",
                        textvie: "* Khi hết hạn voucher sẽ tự mất mà không chuyển lại thành AzCoin",
                        texteng: "* When the voucher expires, it will automatically disappear without being converted back to AzCoin.",
                    },
                    {
                        type: "content",
                        textvie: "* Không có giá trị về tiền mặt",
                        texteng: "* No cash value.",
                    },  
                ],
                row3: [
                    {
                        type: "div",
                        textvie: "3️⃣ Hướng dẫn sử dụng và thao tác cho lễ tân",
                        texteng: "3️⃣ User Guide and Operations for Receptionists",
                    },
                    {
                        type: "content",
                        textvie: "Video hướng dẫn sử dụng:",
                        texteng: "Instructional video:",
                    },  
                    {
                        type: "iframe",
                        textvie: "UCCXyKJeJw4?si=NLD72a4med8iwdgh",
                        texteng: "UCCXyKJeJw4?si=NLD72a4med8iwdgh",
                    },  
                    {
                        type: "content",
                        textvie: "Khách hàng có thể truy cập vào phần Coupo trên ứng dụng để qui đổi",
                        texteng: "Customers can access the Coupo section on the application to exchange.",
                    },
                     {
                        type: "content",
                        style: { fontStyle: "italic", color: "#555", marginTop: "10px" },
                        textvie: "💡 Lưu ý: Mỗi voucher chỉ dùng 1 lần và không hoàn lại khi hủy đặt phòng.",
                        texteng: "💡 Note: Each voucher can only be used once and is non-refundable when the booking is canceled."
                    },
                ],
                row4: [
                    {
                        type: "div",
                        textvie: "4️⃣ Hướng dẫn thao tác qui đổi cho khách",
                        texteng: "4️⃣ Instructions for Customers on How to Exchange",
                    },
                    {
                        type: "content",
                        textvie: "Khách hàng có thể truy cập vào phần Coupo trên ứng dụng để qui đổi",
                        texteng: "Customers can access the Coupo section on the application to exchange.",
                    },  
                    {
                        type: "image",
                        option: "https://database.azumayareport.com/img/guide/membership/coupo_1.jpg",
                        textvie: "Khách vào phần Coupon trên ứng dụng Azumaya",
                        texteng: "Customers go to the Coupon section on the Azumaya App.",
                        style: {width:"600px"}
                    },  
                ],
                row5: [
                    {
                        type: "div",
                        textvie: "5️⃣ Tích tem Rotenburo",
                        texteng: "5️⃣ Collect Rotenburo stamps",
                    },
                    {
                        type: "content",
                        textvie: "Khách hàng có thể truy cập vào phần Coupo trên ứng dụng để qui đổi",
                        texteng: "Customers can access the Coupo section on the application to exchange.",
                    }, 
                ]
            },
            benefit: {
                row1: [
                    {
                        type: "div",
                        textvie: "1️⃣ Nguyên tắc xếp hạng",
                        texteng: "1️⃣ Ranking principles"
                    },
                    {
                        type: "content",
                        textvie: "Khách hàng chi tiêu đặt phòng đạt các mức tiền tương ứng sẽ được lên rank ( VND / USD)",
                        texteng: "Customers who spend the corresponding amounts on room bookings will be upgraded to a higher rank (VND/USD)."
                    },
                    {
                        type: "image",
                        option: "https://database.azumayareport.com/img/guide/membership/benefit1.webp",
                        textvie: "Các mức rank theo chi tiêu",
                        texteng: "Rank levels based on spending.",
                        style: {width:"900px"}
                    },  
                ],
                row2: [
                    {
                        type: "div",
                        textvie: "2️⃣ Minibar đầy đủ",
                        texteng: "2️⃣ Full minibar"
                    },
                    {
                        type: "content",
                        textvie: "Khách hàng là thành viên sẽ được Full minibar gồm 2 nước, pocari, coca, bia ( tuỳ theo chi nhánh và khu vực)",
                        texteng: "Customers who are members will receive a full minibar including 2 bottles of water, Pocari, Coca-Cola, and beer (depending on the branch and location)."
                    },
                    {
                        type: "content",
                        textvie: "Nguyên tắc áp dụng theo bảng bên dưới:",
                        texteng: "The principles to be applied are as shown in the table below:"
                    },
                    {
                        type: "image",
                        option: "https://database.azumayareport.com/img/guide/membership/benefit2.webp",
                        textvie: "Minibar nguyên tắc",
                        texteng:  "Minibar Rule",
                        style: {width:"900px"}
                    },  
                ],
                row3: [
                    {
                        type: "div",
                        textvie: "3️⃣ Nguyên tắc AzCoin",
                        texteng: "3️⃣ AzCoin principles"
                    },
                    {
                        type: "content",
                        textvie: "Sau 13h hệ thống sẽ tính toán để trả AzCoin cho khách hàng.",
                        texteng: "After 13:00, the system will calculate and pay AzCoin to customers."
                    },
                    {
                        type: "content",
                        textvie: "Mức trả sẽ theo mức rank của khách.",
                        texteng: "The payment amount will depend on the customer's rank."
                    },
                    {
                        type: "content",
                        textvie: "Ví dụ khách đang rank Gold và đã trả 4.000.000vnd ( chưa thuế)",
                        texteng: "For example, if the customer is ranked Gold and has paid 4,000,000 VND (excluding tax):"
                    },
                    {
                        type: "content",
                        textvie: "(4.000.000 /20.000)* 0.02 = 4  azCoin",
                        texteng: "(4.000.000 /20.000)* 0.02 = 4  azCoin"
                    },
                    {
                        type: "content",
                        textvie: "Trong đó:",
                        texteng: "Where:"
                    },
                    {
                        type: "content",
                        textvie: "+ 4.000.000 là số tiền khách trả ( chưa gồm thuế )",
                        texteng: "+ 4,000,000 is the amount the customer paid (excluding tax)"
                    },
                    {
                        type: "content",
                        textvie: "+ 20.000 là tỷ giá qui đổi từ VND -> USD",
                        texteng: "+ 20,000 is the exchange rate from VND to USD"
                    },
                    {
                        type: "content",
                        textvie: "+ 0.02 là rank Gold của khách.",
                        texteng: "+ 0.02 is the customer's Gold rank multiplier."
                    },
                    {
                        type: "image",
                        option: "https://database.azumayareport.com/img/guide/membership/benefit1.webp",
                        textvie: "Các mức rank theo chi tiêu",
                        texteng: "Rank levels based on spending.",
                        style: {width:"900px"}
                    },  
                ]
            },
            login: {
                row1: [
                    {
                        type: "div",
                        textvie: "1️⃣ Đăng nhập vào hệ thống Azumaya",
                        texteng: "1️⃣ Log in to the Azumaya system",
                    },
                    {
                        type: "content",
                        textvie: "Có thể sử dụng 3 hình thức:",
                        texteng: "Three methods can be used:",
                    },
                    {
                        type: "content",
                        textvie: "• Email và Mật khẩu",
                        texteng: "• Email and Password",
                    },
                    {
                        type: "content",
                        textvie: "• Apple ID (IOS)",
                        texteng: "• Apple ID (IOS)",
                    },
                    {
                        type: "content",
                        textvie: "• Google (Android + IOS)",
                        texteng: "• Google (Android + IOS)",
                    },
                   {
                        type: "image",
                        option: "https://database.azumayareport.com/img/guide/membership/login1.webp",
                        textvie: "Màn hình login",
                        texteng: "Login Screen",
                        style: {width:"500px"}
                    },  
                    {
                        type: "content",
                        textvie: "* Khách chọn đăng nhập Email sẽ cần xác minh Email",
                        texteng: "* Customers choosing to log in via Email will need to verify their Email.",
                    },
                    {
                        type: "image",
                        option: "https://database.azumayareport.com/img/guide/membership/login2.webp",
                        textvie: "Xác thực địa chỉ mail",
                        texteng: "Verify email address",
                        style: {width:"600px"}
                    },
                ],
                row2: [
                    {
                        type: "div",
                        textvie: "2️⃣ Quên mật khẩu",
                        texteng: "2️⃣ Forgot Password",
                    },
                    {
                        type: "content",
                        textvie: "Nhấn vào Quên mật khẩu trên trang đăng nhập và làm theo hướng dẫn để đặt lại mật khẩu.",
                        texteng: "Click on Forgot Password on the login page and follow the instructions to reset your password.",
                    },
                    {
                        type: "image",
                        option: "https://database.azumayareport.com/img/guide/membership/login3.webp",
                        textvie: "Nhấp vào Quên mật khẩu",
                        texteng: "Click Forgot Password",
                        style: {width:"600px"}
                    },
                ],
                row3: [
                    {
                        type: "div",
                        textvie: "3️⃣ Qui tắc thêm khách của Database <=> Membership",
                        texteng: "3️⃣ Database Guest Addition Rule <=> Membership",
                    },
                    {
                        type: "content",
                        textvie: "Khi khách có đủ các thông tin về tên + mail sẽ được tạo trên Database.",
                        texteng: "When the customer has enough information about name + email, it will be created on the Database.",
                    },
                    {
                        type: "content",
                        textvie: "Các thông tin khớp với Database sẽ được thêm trực tiếp vào profile.",
                        texteng: "Information that matches the Database will be added directly to the profile.",
                    },
                                        {
                        type: "image",
                        option: "https://database.azumayareport.com/img/guide/membership/login4.webp",
                        textvie: "Profile có Membership và không có",
                        texteng: "Profile with and without Membership",
                        style: {width:"600px"}
                    },
                ],
            },
            loyaltyCard: {
                row1: [
                    {
                        type: "div",
                        textvie: "1️⃣ Stamp Card là gì?",
                        texteng: "1️⃣ What is a Stamp Card?"
                    },
                    {
                        type: "content",
                        textvie: "Thẻ stamp giúp tích điểm và nhận quà từ Azumaya.",
                        texteng: "The stamp card helps collect points and receive rewards from Azumaya."
                    },
                    {
                        type: "content",
                        textvie: "Hiện tại đang cung cấp tích điểm Rotenburo và Massage ( tuỳ theo chi nhánh).",
                        texteng: "Currently offering Rotenburo and Massage points (depending on the branch)."
                    },
                                        {
                        type: "content",
                        textvie: "=> Sử dụng 5 lần tặng 1 lần miễn phí",
                        texteng: "=> Use 5 times get 1 free"
                    },
                    {
                        type: "image",
                        option: "https://database.azumayareport.com/img/guide/membership/loyalty_card1.webp",
                        textvie: "Kích vào thẻ tích điểm",
                        texteng: "Click on the loyalty card",
                        style: {width:"400px"}
                    },
                ],
                row2: [
                    {
                        type: "div",
                        textvie: "3️⃣ Hiển thị mã QR",
                        texteng: "3️⃣ Show QR code"
                    },
                    {
                        type: "content",
                        textvie: "Đưa mã tích điểm để Lễ tân có thể quét mã QR code",
                        texteng: "Give the loyalty code so that the receptionist can scan the QR code"
                    },
                    {
                        type: "content",
                        textvie: "Lễ tân có thể chụp lại ảnh màn hình điện thoại ( nút volume - và nút nguồn) để lưu lại ảnh đã sử dụng dịch vụ",
                        texteng: "Receptionist can take a screenshot of the phone screen (volume button - and power button) to save the photo of the service used."
                    },
                    {
                        type: "image",
                        option: "https://database.azumayareport.com/img/guide/membership/loyalty_card3.webp",
                        textvie: "Hiển thị mã QR",
                        texteng: "Show QR code",
                        style: {width:"400px"}
                    },
                ],
                row3: [
                    {
                        type: "div",
                        textvie: "2️⃣ Cách tính điểm và quà",
                        texteng: "2️⃣ How to calculate points and gifts"
                    },
                    {
                        type: "content",
                        textvie: "Khách hàng sẽ truy cập vào nút Stamp Card",
                        texteng: "Customers click Stamp Card button on homeside"
                    },
                    {
                        type: "content",
                        textvie: "Có các thẻ tích điểm đang khả dụng, click vào QR code để bất đầu tích điểm",
                        texteng: "Loyalty cards are available, click on the QR code to start earning points"
                    },
                    {
                        type: "image",
                        option: "https://database.azumayareport.com/img/guide/membership/loyalty_card2.webp",
                        textvie: "Kích vào thẻ tích điểm",
                        texteng: "Click on the loyalty card",
                        style: {width:"400px"}
                    },
                    {
                        type: "iframe",
                        textvie: "paKClzq3Udk",
                        texteng: "paKClzq3Udk"
                    },
                    {
                        type: "content",
                        textvie: "Video hướng dẫn tích điểm",
                        texteng: "Video guide to earning points"
                    },
                ]
            },
            other: {
                row1:{
                  row4:[
                    {
                        type: "div",
                        textvie: "1️⃣ Tìm kiếm khách hàng",
                        texteng: "1️⃣ Find customers",
                    },
                ]
                }
            }
        }
    };

export default function MembershipGude() {
    const [tab, setTab] = useState("Login");
    const [guiderData, setGuiderData] = useState({});
    const tabs = ["Login", "Rule & Benefit", "Voucher", "Stamp Card", "Other", "Q & A"];
    const [lang, setLang] = useState("vie");


    const TAB_ICONS = {
        "Login": "🔐",
        "Rule & Benefit": "💳",
        "Voucher":  "💳",
        "Stamp Card": "💳",
        "Other": "🧾",
        "Q & A": "❓",
        // you can replace the emojis with image URLs if you prefer:
        // "Login": "https://example.com/icons/login.png",
    };

    useEffect(() => {
        const loadData = async () => {
            const resulData = await otherSetupApi.takeByTarget("membershipGuide");
            setGuiderData(resulData.data.data)
           // console.log("resulData", resulData)
        }

        loadData();
    },[])

    function getTabIcon(tab, size = 20) {
        const icon = TAB_ICONS[tab];
        if (!icon) return null;
        // if icon is an emoji or plain text:
        if (icon.length <= 2) {
            return <span style={{ marginRight: 8, fontSize: size }}>{icon}</span>;
        }
        // otherwise assume it's an URL:
        return <img src={icon} alt={`${tab}-icon`} style={{ width: size, height: size, marginRight: 8 }} />;
    }



    const handleTabChange = (selectedTab) => {
        setTab(selectedTab);
    };

    function renderWithTab() {
        switch(tab) {
            case "Login": return  (<div className="ml-4 membership-voucher_content">{renderContentWithTarget(guiderData.login)}</div>)
            case "Rule & Benefit": return  (<div className="ml-4 membership-voucher_content">{renderContentWithTarget(guiderData.benefit)}</div>)
            case "Voucher":  return voucherContent() ;
            case "Stamp Card" : return  (<div className="ml-4 membership-voucher_content">{renderContentWithTarget(guiderData.loyaltyCard)}</div>)
            case "Other": return <div style={{marginTop: "16px"}}>We’re working hard to bring you something great!.</div>;
            case "Q & A": return <div style={{marginTop: "16px"}}>We’re working hard to bring you something great!</div>;
            default:
                return null;
        }   
    };

    function renderWithRequest(type, text, option, style) {
        switch(type) {
            case "div":  return <div className="voucher-title">{text}</div>
            case "content":
                return <p style={style}>{text}</p>;
            case "image":
                return <div>
                    <img src={option} alt="content" style={style}/>
                    <h5 style={{textAlign:"center",fontStyle: "italic" }}>{text}</h5>
                </div>;
            case "iframe":
                return <iframe width="650" height="330" 
                    src={`https://www.youtube.com/embed/${text}` }
                    title="YouTube video player" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerpolicy="strict-origin-when-cross-origin" 
                    allowfullscreen></iframe>
            default:
                return null;
        }
    };

    function renderContent2(structure) {
        let result  = []
        if(structure.length > 0) {
            structure.forEach((item, index) => {
                result.push(renderWithRequest(item.type, item["text"+lang], item.option, item.style));
            });
        }
        return result;
    }

    function renderContentWithTarget(renderItem) {
        let result = [];
        const keyOnObject = Object.keys(renderItem);

        keyOnObject.forEach(item => {
            result.push(<section style={{ marginTop: 10, textAlign: "left" }}>{renderContent2(renderItem[item])}</section>)
        })

        return result;
    }

    function voucherContent() {
        return (<div className="ml-4 membership-voucher_content">
            {/* <div>This is the Voucher tab content.</div> */}
            <section style={{ marginTop: 10, textAlign: "left" }}>{renderContent2(guiderData.voucher.row1)}</section>
            <section style={{ marginTop: 10, textAlign: "left" }}>{renderContent2(guiderData.voucher.row2)}</section>

            <table className="">
                  <tr>
                    <th className="membership-voucher-content_table-th" rowspan="2"></th>
                    <th className="membership-voucher-content_table-th" colspan="2">Ha Noi</th>
                    <th className="membership-voucher-content_table-th" colspan="2">Hai Phong</th>
                    <th className="membership-voucher-content_table-th" colspan="2">Da Nang</th>
                    <th className="membership-voucher-content_table-th" colspan="2">Ho Chi Minh</th>
                    <th className="membership-voucher-content_table-th" colspan="2">Phnom Penh</th>
                </tr>
                <tr>
                    <th className="membership-voucher-content_table-th">VND</th><th className="membership-voucher-content_table-th">azCoin</th>
                    <th className="membership-voucher-content_table-th">VND</th><th className="membership-voucher-content_table-th">azCoin</th>
                    <th className="membership-voucher-content_table-th">VND</th><th className="membership-voucher-content_table-th">azCoin</th>
                    <th className="membership-voucher-content_table-th">VND</th><th className="membership-voucher-content_table-th">azCoin</th>
                    <th className="membership-voucher-content_table-th">USD</th><th className="membership-voucher-content_table-th">azCoin</th>
                </tr>
                  <tr>
                    <td className="membership-voucher-content_table-td category"  rowspan="2">Rotenburo<br></br></td>
                    <td className="membership-voucher-content_table-td ">150,000</td><td className="membership-voucher-content_table-td ">7.5</td>
                    <td className="membership-voucher-content_table-td ">150,000</td><td className="membership-voucher-content_table-td ">7.5</td>
                    <td className="membership-voucher-content_table-td ">150,000</td><td className="membership-voucher-content_table-td ">7.5</td>
                    <td className="membership-voucher-content_table-td ">250,000</td><td className="membership-voucher-content_table-td ">12.5</td>
                    <td className="membership-voucher-content_table-td ">8</td><td className="membership-voucher-content_table-td ">8</td>
                </tr>
                <tr>
                    <td className="membership-voucher-content_table-td ">100,000</td><td className="membership-voucher-content_table-td ">5</td>
                    <td className="membership-voucher-content_table-td ">100,000</td><td className="membership-voucher-content_table-td ">5</td>
                    <td className="membership-voucher-content_table-td ">100,000</td><td className="membership-voucher-content_table-td ">5</td>
                    <td className="membership-voucher-content_table-td ">200,000</td><td className="membership-voucher-content_table-td ">10</td>
                    <td className="membership-voucher-content_table-td ">10</td><td className="membership-voucher-content_table-td ">10</td>
                </tr>

                 <tr>
                    <td className="membership-voucher-content_table-td category" rowspan="3">Massage</td>
                    <td className="membership-voucher-content_table-td ">300,000</td><td className="membership-voucher-content_table-td ">15</td>
                    <td className="membership-voucher-content_table-td "></td><td className="membership-voucher-content_table-td "></td>
                    <td className="membership-voucher-content_table-td ">200,000</td><td className="membership-voucher-content_table-td ">10</td>
                    <td className="membership-voucher-content_table-td ">300,000</td><td className="membership-voucher-content_table-td ">15</td>
                    <td className="membership-voucher-content_table-td ">10</td><td className="membership-voucher-content_table-td ">10</td>
                </tr>
                <tr>
                    <td className="membership-voucher-content_table-td ">350,000</td><td className="membership-voucher-content_table-td ">17.5</td>
                    <td className="membership-voucher-content_table-td "></td><td className="membership-voucher-content_table-td "></td>
                    <td className="membership-voucher-content_table-td ">300,000</td><td className="membership-voucher-content_table-td ">15</td>
                    <td className="membership-voucher-content_table-td ">350,000</td><td className="membership-voucher-content_table-td ">17.5</td>
                    <td className="membership-voucher-content_table-td ">15</td><td className="membership-voucher-content_table-td ">15</td>
                </tr>
                <tr>
                    <td className="membership-voucher-content_table-td ">450,000</td><td className="membership-voucher-content_table-td ">22.5</td>
                    <td className="membership-voucher-content_table-td "></td><td className="membership-voucher-content_table-td "></td>
                    <td className="membership-voucher-content_table-td ">400,000</td><td className="membership-voucher-content_table-td ">20</td>
                    <td className="membership-voucher-content_table-td ">450,000</td><td className="membership-voucher-content_table-td ">22.5</td>
                    <td className="membership-voucher-content_table-td ">20</td><td className="membership-voucher-content_table-td ">20</td>
                </tr>
            </table>

            <section style={{ marginTop: 20, textAlign: "left" }}>{renderContent2(guiderData.voucher.row3)}</section>
            <section style={{ marginTop: 20, textAlign: "left" }}>{renderContent2(guiderData.voucher.row4)}</section>
            <section style={{ marginTop: 20, textAlign: "left" }}>{renderContent2(guiderData.voucher.row5)}</section>

        </div>);
    }

    return (
        <div >
            <h1>Membership Guide Page</h1>
             <div>
                 <img src="https://database.azumayareport.com/img/guide/icon/flag_vie.png" alt="Tiếng Việt"
                        onClick={() => setLang("vie")}
                        style={{width:"45px", borderRadius:'50%', opacity:lang === "vie" ? "unset": '20%'}}></img>
                 <img src="https://database.azumayareport.com/img/guide/icon/flag_eng.png" alt="English"
                        onClick={() => setLang("eng")}
                        style={{width:"45px", borderRadius:'50%', opacity:lang === "eng" ? "unset": '20%'}}></img>
            </div>
            {
              Object.keys(guiderData).length > 0 &&  <div style={{ display: 'flex', alignItems: 'flex-start', fontSize: '1.5rem', }}>
                <ul style={{ listStyleType: 'none', padding: 0, margin: 0,  position:'fixed', top: '60px' }}>
                    {tabs.map((item) => (
                        <li 
                            key={item} 
                            onClick={() => handleTabChange(item)} 
                            style={{ 
                                cursor: 'pointer', 
                                padding: '10px 20px', 
                                backgroundColor: tab === item ? 'yellow' : '#fff', 
                                border: '1px solid #ccc', 
                                borderRadius: '5px', 
                                marginBottom: '5px', 
                                width: '200px',
                                transition: 'background-color 0.3s' 
                            }}
                            // onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                            // onMouseLeave={(e) => e.currentTarget.style.backgroundColor = tab === item ? '#ddd' : '#fff'}
                        >
                            {getTabIcon(item)}{item}
                        </li>
                    ))}
                </ul>
                {/* <div style={{ marginLeft: '20px' }}>
                    <h3>Selected Tab: {tab}</h3>
                </div> */}
                <div style={{marginLeft:"200px"}}>
                      {renderWithTab()}
               </div>
            </div>
            }
         
        </div>
    );
}
